import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Contact = () => {
  const { t } = useTranslation();

  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const consent = localStorage.getItem('cookieConsent');
      if (consent === 'accepted') {
        setShowMap(true);
      }
    };
    
    // Check on mount
    checkConsent();
    
    // Listen for cookie consent acceptance
    window.addEventListener('cookieConsentAccepted', checkConsent);
    
    return () => {
      window.removeEventListener('cookieConsentAccepted', checkConsent);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Infinity Energy Solar – Contact</title>
      </Helmet>
      <div className="pt-24 pb-16 px-4 text-[#173861]">
        <h1 className="text-4xl font-bold text-center mb-6">{t('contactHero')}</h1>

        <p className="max-w-3xl mx-auto text-lg text-center mb-12">
          {t('contactText')}
        </p>

        <div className="group relative overflow-hidden rounded-xl bg-white shadow-md border border-green-600 hover:border-green-600 transition duration-300 mb-10 max-w-4xl mx-auto">
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">{t('contactTitle')}</h2>
            <p><strong>{t('contactPhone')}:</strong>{' '}
              <a href="tel:+359879275550" className="text-emerald-500 hover:text-emerald-600">+359 879 27 55 50</a>
            </p>
            <p><strong>{t('contactEmail')}:</strong>{' '}
              <a href="mailto:office@infisolarbg.com" className="text-emerald-500 hover:text-emerald-600 underline">office@infisolarbg.com</a>
            </p>
            <p><strong>{t('contactAddress')}:</strong>{' '}
              <span className="text-emerald-500">{t('contactFullAddress')}</span>
            </p>
          </div>
          <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
        </div>

        <div className="max-w-4xl mx-auto rounded-xl overflow-hidden shadow-lg">
          {showMap ? (
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5182.499650983414!2d23.465461899999994!3d41.8870833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ababdc3777e4d9%3A0x2fb29127ccdf6983!2sInfinity%20Energy%20Solar!5e1!3m2!1sen!2sbg!4v1744375129602!5m2!1sen!2sbg"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Infinity Energy Solar Location"
            ></iframe>
          ) : (
            <div className="text-center text-gray-600 italic py-10">
              {t('mapConsentRequired') || 'Map is disabled until cookies are accepted.'}
            </div>
          )}
        </div>

        <div className="group relative overflow-hidden rounded-xl bg-white shadow-md border border-green-600 hover:border-green-600 transition duration-300 mb-10 max-w-4xl mx-auto mt-10">
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">{t('employeesTitle')}</h2>
            <h2 className="text-1xl font-regular mb-4">{t('employeesInfo')}</h2>
            <p><strong>{t('contactPhone')}:</strong>{' '}
              <a href="tel:+359896762334" className="text-emerald-500 hover:text-emerald-600">+359 896 76 23 34</a>
            </p>
            <p><strong>{t('contactEmail')}:</strong>{' '}
              <a href="mailto:employees@infisolarbg.com" className="text-emerald-500 hover:text-emerald-600 underline">employees@infisolarbg.com</a>
            </p>
          </div>
          <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
        </div>
      </div>
    </>
  );
};

export default Contact;
